<script setup>
import SubscriptionManage from '@/components/subscription/SubscriptionManage.vue'
</script>

<template>
  <subscription-manage />
</template>
